import React from 'react';

const CasinoWagerPercentPerPlayer = () => {
    return (
        <div>

        </div>
    )
}

export default CasinoWagerPercentPerPlayer;